<template>
  <div class="row">
    <table class="table">
      <tr>
        <td>2022-04-03</td>
        <td>여러장 검색 기능 추가</td>
      </tr>
      <tr>
        <td>2022-07-14</td>
        <td>Enter누르면 검색 되게 수정, History기능 추가</td>
      </tr>
    </table>
  </div>
  <BibleFinderFooter/>
</template>

<script>
import BibleFinderFooter from "@/components/BibleFinderFooter";
export default {
  name: "ReleaseNote",
  components: {BibleFinderFooter}
}
</script>

<style scoped>

</style>
